import { Box, Divider, Paper, Stack, Typography } from '@mui/material';
import type { Nomination } from '../lib/api';

interface GlanceItem {
  label: string;
  value: string;
  color: string;
}

export function AtAGlance({ nomination }: { nomination: Nomination }) {
  const n = nomination as Record<string, unknown>;
  const hasHero = !!n.hero_image;

  let imgN = 0;
  for (let i = 2; i <= 10; i++) { if (n[`image_${i}`]) imgN++; }

  const a2Count = (n.a2board1 ? 1 : 0) + (n.a2board2 ? 1 : 0);
  const hasPres = !!n.presentation_uploaded;
  const hasVideo = !!(n.video_landscape_url || n.video_portrait_url || n.video_download_url);

  const items: GlanceItem[] = [
    { label: 'Hero image', value: hasHero ? 'Yes' : 'No', color: hasHero ? '#22C55E' : '#EF4444' },
    { label: 'Images', value: `${imgN}/9`, color: imgN === 0 ? '#EF4444' : imgN < 5 ? '#F59E0B' : '#22C55E' },
    { label: 'A2 boards', value: `${a2Count}/2`, color: a2Count === 2 ? '#22C55E' : a2Count === 1 ? '#F59E0B' : '#EF4444' },
    { label: 'Presentation', value: hasPres ? 'Yes' : 'No', color: hasPres ? '#22C55E' : '#9CA3AF' },
    { label: 'Video', value: hasVideo ? 'Yes' : 'No', color: hasVideo ? '#22C55E' : '#9CA3AF' },
  ];

  return (
    <Paper sx={{ p: 2 }}>
      <Stack
        direction="row"
        spacing={0}
        divider={<Divider orientation="vertical" flexItem />}
        sx={{ justifyContent: 'space-around' }}
      >
        {items.map((item) => (
          <Box key={item.label} sx={{ textAlign: 'center', flex: 1, px: 2 }}>
            <Typography variant="caption" color="text.secondary">{item.label}</Typography>
            <Typography variant="h6" sx={{ color: item.color, fontWeight: 700 }}>{item.value}</Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
